<script lang="ts" setup>
import KpModal from '@kp/geofy-vuejs-lib/tg-system/components/KpModal.vue';
import { apiUrl, appUrl } from '@/helpers/api';

const props = withDefaults(
    defineProps<{
        redirectUrl?: string;
    }>(),
    {
        redirectUrl: appUrl('/')
    }
);

const show = defineModel({ default: false });

function gotoAgov() {
    document.location.href = apiUrl('/oidc/login', { url: props.redirectUrl });
}
</script>

<template>
    <KpModal v-model="show">
        <h2 class="ktg-modal-title">{{ $t('agov_konto_required_title') }}</h2>
        <div class="ktg-modal-text" v-html="$t('agov_info_body')" />
        <ktg-link trailing-icon="long-arrow-right" :href="appUrl('help/faq')">{{ $t('more_infos_account') }} </ktg-link>

        <ktg-modal-buttons vertical="" slot="buttons"
            ><ktg-button
                appearance="primary"
                full-width=""
                size="small"
                @click="gotoAgov"
                >{{ $t('weiter_zu_agov') }}</ktg-button
            ></ktg-modal-buttons
        >
    </KpModal>
</template>